import React from 'react';
import LockIcon from '@assets/icons/lock.svg';
import { BaseButton } from '@components';
import { TEST_IDS } from '@constants/testIds.ts';
import { BodyMdMd, HeadingSm } from '@constants/text.ts';
import {
    SHARED_LOCKED_CONTENT_BUTTON,
    SHARED_LOCKED_CONTENT_DESCRIPTION,
    SHARED_LOCKED_CONTENT_TITLE,
} from '@routes/sidebar/learning/ui/learning-tab/locked-content/constants.ts';
import {
    LockedButtons,
    LockedContentWrapper,
    LockedInfo,
} from '@routes/sidebar/learning/ui/learning-tab/locked-content/styled.tsx';
import { scrollToElementByRefOrId } from '@utils/scroll.ts';
import { translateItem } from '@utils/translations.ts';

interface Props {
    elementIdToScrollTo: string;
}

export const LockedContent: React.FC<Props> = ({ elementIdToScrollTo }) => {
    return (
        <LockedContentWrapper data-cy={TEST_IDS.LEARNING.LOCKED_CONTENT}>
            <LockedInfo>
                <div>
                    <div>
                        <LockIcon />
                    </div>
                </div>
                <span>
                    <HeadingSm data-cy={TEST_IDS.LEARNING.LOCKED_CONTENT_TITLE}>
                        {translateItem(SHARED_LOCKED_CONTENT_TITLE)}
                    </HeadingSm>
                    <BodyMdMd data-cy={TEST_IDS.LEARNING.LOCKED_CONTENT_DESCRIPTION}>
                        {translateItem(SHARED_LOCKED_CONTENT_DESCRIPTION)}
                    </BodyMdMd>
                </span>
                <LockedButtons>
                    <BaseButton
                        data-cy={TEST_IDS.LEARNING.LOCKED_CONTENT_BUTTON}
                        onClick={() => scrollToElementByRefOrId(null, elementIdToScrollTo)}
                    >
                        {translateItem(SHARED_LOCKED_CONTENT_BUTTON)}
                    </BaseButton>
                </LockedButtons>
            </LockedInfo>
        </LockedContentWrapper>
    );
};
